import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zerosEsquerda'
})
export class ZerosAEsquerda implements PipeTransform {
    transform(texto: string, qtdZeros: number): string {

        if (texto == null || texto === '') { return ''; }

        let zerosString = '0';
        zerosString = zerosString.repeat(qtdZeros);
        return `${zerosString}${texto}`.substr(qtdZeros * -1, qtdZeros);
    }
}
